import React, { Component, Fragment } from 'react'
import AppURL from '../api/AppURL'

import FooterDesktop from '../components/common/FooterDesktop'
import FooterMobile from '../components/common/FooterMobile'
import NavMenuDesktop from '../components/common/NavMenuDesktop'
import NavMenuMobile from '../components/common/NavMenuMobile'
import FeaturedProducts from '../components/home/FeaturedProducts'
import NewArrival from '../components/home/NewArrival'
import HomeTop from '../components/home/HomeTop'
import HomeTopMobile from '../components/home/HomeTopMobile'
import About_us from '../components/home/About_us'
import Service from '../components/home/Service'
import LiveDemo from '../components/home/LiveDemo'
import NewsletterSubscribe from '../components/others/NewsletterSubscribe'
import HomeVideos from '../components/home/HomeVideos'

import axios from 'axios'



export class HomePage extends Component {
     componentDidMount(){
       window.scroll(0,0);
          this.GetVisitorDetails();

     }
            GetVisitorDetails =()=>{
          axios.get(AppURL.VisitorDetails).then().catch()
    
     }

  render() {
    return (
<Fragment>
    
                      <div className="Desktop">
               <NavMenuDesktop />
               <HomeTop />
                    </div>

                    <div className="Mobile">
                    <NavMenuMobile />  
                    <HomeTopMobile />
                    </div> 
  <About_us/>
      <FeaturedProducts/>
      <Service/>
      <NewArrival />
      
          < LiveDemo/>
          <HomeVideos/>
        <NewsletterSubscribe/>
          <div className="Desktop">
            <FooterDesktop/>
          </div>

                    <div className="Mobile">
                    <FooterMobile/>
                    </div>
    
</Fragment>
    )
  }
}

export default HomePage
